export const DEFAULT_LOCALE = 'en_US'

const navigatorLanguage =
  (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  navigator.userLanguage ||
  DEFAULT_LOCALE

export const language = navigatorLanguage.toLowerCase().split(/[_-]+/)[0]
export const languageCode = navigatorLanguage
